import {useEffect, useState} from "react";
import {BreadCrumbs} from "../../../components/open/pages";
import {AuthRedirectAdmins, PostJSON} from "../../../components/api/webservice";
import {Apis} from "../../../components/api/url";
import {HideProgressLoading} from "../../../components/template/architecture";
import {Link} from "react-router-dom";
import {ThinArrowLeft, ThinChatIcon, ThinChatUnreadIcon} from "../../../components/icons/material-icons";
import {StringDigitsConvertToPersian} from "../../../components/techaran/money";
import {GregorianToPersian} from "../../../components/techaran/date-convert";

interface requestInterface {
    id: number,
    name: string,
    createdAt: string,
    isSessionHeld: boolean,
    title:string,
}

export const AdminsConsultRequestsScreen = () => {
    const [loaded, setLoaded] = useState(false);
    const [list, setList] = useState<requestInterface[]>([]);
    const fetchList = () => {
        PostJSON(
            Apis.server + '/core/admins/consult/requests/list',
            {},
            true,
            (d: {
                result: string,
                reason: string,
                list: requestInterface[] | null,
            }) => {
                HideProgressLoading();
                if (d.result !== 'OK') {
                    if (d.reason === 'login')
                        AuthRedirectAdmins();
                    return;
                }
                setLoaded(true);
                setList(d.list === null ? [] : d.list);
            },
            () => {
            },
            AuthRedirectAdmins,
        ).then(void 0);
    };
    useEffect(() => {
        document.title = "درخواست ها | مشاوره | اتوماسیون";
        fetchList();
    }, []);
    return (
        <>
            <BreadCrumbs links={[
                {title: 'اتوماسیون', url: '/admins/'},
                {title: 'مشاوره', url: '/admins/consult'},
                {title: 'درخواست ها', url: '/admins/consult/requests'},
            ]}/>
            {
                loaded ?
                    <div className="container" data-aos="fade-up" data-aos-duration={1000}>
                        <div className="screen-card">
                            <div className="screen-card-header">
                                <b>درخواست‌های مشاوره</b>
                            </div>
                            {
                                list.map((t, i) =>
                                    <Link to={`/admins/consult/requests/view/${t.id}`}
                                          key={"J39fFk39Dkl23"+i}
                                          className={'ticket-item' + (t.isSessionHeld ? ' ticket-item-closed' : '')}>
                                        <div>
                                            <i>{!t.isSessionHeld ? <ThinChatUnreadIcon/> : <ThinChatIcon/>}</i>
                                            <div>
                                                <b className={"max-lines-1"}>{t.title}</b>
                                                <span>توسط {t.name} در تاریخ {StringDigitsConvertToPersian(GregorianToPersian(t.createdAt).replaceAll('-','/'))} و ساعت {StringDigitsConvertToPersian(t.createdAt.split(' ')[1])} - {t.isSessionHeld ? 'جلسه برگزار شده' : 'در انتظار پاسخ'}</span>
                                            </div>
                                        </div>
                                        <ThinArrowLeft/>
                                    </Link>
                                )
                            }
                        </div>
                    </div> : null
            }
        </>
    );
};